/* Køkkenstue · interaktionsfysik */
(function(){
  var RM=matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE=matchMedia('(pointer: fine)').matches;
  var doc=document.documentElement;
  doc.classList.add('k-fx');
  var lerp=function(a,b,t){return a+(b-a)*t};
  var clamp=function(v,a,b){return Math.max(a,Math.min(b,v))};
  var mx=innerWidth/2,my=innerHeight/2;
  addEventListener('mousemove',function(e){mx=e.clientX;my=e.clientY},{passive:true});

  var bar=document.createElement('div');bar.className='k-progress';document.body.appendChild(bar);

  function split(el){
    if(el.dataset.kSplit)return;el.dataset.kSplit=1;
    var i=0,walk=document.createTreeWalker(el,NodeFilter.SHOW_TEXT,null),nodes=[];
    while(walk.nextNode())nodes.push(walk.currentNode);
    nodes.forEach(function(n){
      if(!n.nodeValue.trim())return;
      var frag=document.createDocumentFragment();
      n.nodeValue.split(/(\s+)/).forEach(function(w){
        if(!w)return;
        if(/^\s+$/.test(w)){frag.appendChild(document.createTextNode(w));return}
        var o=document.createElement('span');o.className='k-w';
        var inner=document.createElement('span');inner.className='k-wi';inner.style.setProperty('--i',i++);inner.textContent=w;
        o.appendChild(inner);frag.appendChild(o);
      });
      n.parentNode.replaceChild(frag,n);
    });
    el.classList.add('k-split');
  }
  if(!RM&&'IntersectionObserver' in window){
    var targets=document.querySelectorAll('.k-sec .k-h2,.k-story .k-h2,.k-final .k-display,.k-feature__title,.k-cban .k-h2,.k-edit .k-h2');
    var sio=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-split-in');sio.unobserve(e.target)}})},{threshold:.25});
    targets.forEach(function(t){split(t);sio.observe(t)});
  }

  if(RM)return;

  var lamp=document.createElement('div');lamp.className='k-lamp';document.body.appendChild(lamp);

  var ring,dot,label,rx=mx,ry=my;
  if(FINE){
    doc.classList.add('k-has-cursor');
    ring=document.createElement('div');ring.className='k-cursor';label=document.createElement('span');ring.appendChild(label);
    dot=document.createElement('div');dot.className='k-cursor-dot';
    document.body.appendChild(ring);document.body.appendChild(dot);
    document.addEventListener('mouseover',function(e){
      var v=e.target.closest('.k-card,.k-tile,.k-gal__i,.k-feature__media,.k-model');
      var l=e.target.closest('a,button,label,summary,input[type=submit]');
      ring.classList.toggle('is-view',!!v);
      ring.classList.toggle('is-link',!v&&!!l);
      label.textContent=v?(v.classList.contains('k-gal__i')?'KIG':'SE'):'';
    });
    document.addEventListener('mouseleave',function(){ring.style.opacity=dot.style.opacity=0});
    document.addEventListener('mouseenter',function(){ring.style.opacity=dot.style.opacity=1});
    addEventListener('mousedown',function(){ring.style.scale='.85'});
    addEventListener('mouseup',function(){ring.style.scale='1'});
  }

  if(FINE){
    document.querySelectorAll('.k-btn,.k-ibtn,.k-tile__arrow,.k-f2-mail button,.k-feature__dots button').forEach(function(b){
      var s=b.classList.contains('k-btn')?.28:.4;
      b.style.transition='transform .5s cubic-bezier(.2,.9,.25,1.25)';
      b.addEventListener('mousemove',function(e){var r=b.getBoundingClientRect();var dx=e.clientX-(r.left+r.width/2),dy=e.clientY-(r.top+r.height/2);b.style.transform='translate3d('+dx*s+'px,'+dy*s+'px,0)'});
      b.addEventListener('mouseleave',function(){b.style.transform=''});
    });
  }

  if(FINE){
    document.querySelectorAll('.k-card__img,.k-tile,.k-feature__media,.k-gal__i,.k-life__a,.k-life__img').forEach(function(el){
      el.classList.add('k-tilt');
      var tx=0,ty=0,cx=0,cy=0,raf=null,max=el.classList.contains('k-card__img')?9:5;
      function step(){cx=lerp(cx,tx,.12);cy=lerp(cy,ty,.12);el.style.transform='perspective(900px) rotateX('+cy.toFixed(2)+'deg) rotateY('+cx.toFixed(2)+'deg) scale('+(1+Math.min(1,(Math.abs(cx)+Math.abs(cy))/max)*.025)+')';if(Math.abs(cx-tx)>.02||Math.abs(cy-ty)>.02){raf=requestAnimationFrame(step)}else{raf=null;if(!tx&&!ty)el.style.transform=''}}
      function go(){if(!raf)raf=requestAnimationFrame(step)}
      el.addEventListener('mousemove',function(e){var r=el.getBoundingClientRect();var px=(e.clientX-r.left)/r.width,py=(e.clientY-r.top)/r.height;tx=(px-.5)*2*max;ty=(.5-py)*2*max;el.style.setProperty('--gx',px*100+'%');el.style.setProperty('--gy',py*100+'%');el.classList.add('is-tilting');go()});
      el.addEventListener('mouseleave',function(){tx=0;ty=0;el.classList.remove('is-tilting');go()});
    });
  }

  var mq=document.querySelector('.k-marquee__in'),mqx=0,mqw=0;
  if(mq){mq.style.animation='none';var measure=function(){mqw=mq.scrollWidth/2};measure();addEventListener('resize',measure)}

  var par=[].slice.call(document.querySelectorAll('.k-gal__i img,.k-life__a img,.k-tile--photo img')).map(function(img,i){return{img:img,box:img.parentElement,s:(i%2?.08:-.06)}});

  var lastY=scrollY,vel=0;
  function frame(){
    var y=scrollY,d=y-lastY;lastY=y;vel=lerp(vel,d,.12);
    var h=document.documentElement.scrollHeight-innerHeight;bar.style.transform='scaleX('+(h>0?y/h:0)+')';
    lamp.style.setProperty('--mx',mx+'px');lamp.style.setProperty('--my',my+'px');
    if(ring){rx=lerp(rx,mx,.16);ry=lerp(ry,my,.16);ring.style.transform='translate3d('+rx+'px,'+ry+'px,0)';dot.style.transform='translate3d('+mx+'px,'+my+'px,0)'}
    if(mq&&mqw){mqx-=(.6+Math.abs(vel)*.35)*(vel<-0.5?-1:1);if(mqx<-mqw)mqx+=mqw;if(mqx>0)mqx-=mqw;mq.style.transform='translate3d('+mqx+'px,0,0) skewX('+clamp(-vel*.25,-12,12)+'deg)'}
    for(var i=0;i<par.length;i++){var p=par[i],r=p.box.getBoundingClientRect();if(r.bottom<0||r.top>innerHeight)continue;var c=(r.top+r.height/2-innerHeight/2);p.img.style.transform='translate3d(0,'+(c*p.s).toFixed(1)+'px,0) scale(1.14)'}
    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);
})();
